// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/dashboard/modules/widget-grid/components/alert-widget/alert-widget.less
// module id = 3339
// module chunks = 0